import {Modal} from "bootstrap";

export default function () {
    /**
     * Ovveride back behaviour
     */
    const alertBackModal = document.querySelector('#alertBackModal');
    const alertBackModalConfirm = alertBackModal.querySelector('.confirm');
    history.pushState(null, null, null);

    function handleBackButton() {
        history.pushState(null, null, null);
        const alertBackModalInstance = new Modal(alertBackModal);
        alertBackModalInstance.show();
    }

    window.addEventListener('popstate', (e) => {
        setTimeout(handleBackButton, 0)
    });
    alertBackModalConfirm.addEventListener('click', () => {
        window.location.href = backButtonUrl;
    });
    const backDisabledItems = document.querySelectorAll('.back-disabled');
    if (backDisabledItems.length) {
        backDisabledItems.forEach((backDisabledItem) => {
            backDisabledItem.addEventListener('click', (e) => {
                e.preventDefault();
                handleBackButton();
            })
        });
    }
}
